import React from "react";

function Adresse({ address }) {
  return (
    <p class="address subtitle helveticaneue-regular-normal dove-gray-16px ">
      {address}
    </p>
  );
}

export default Adresse;
